(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colletion-image-with-text"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener("DOMContentLoaded", function() {
      const leftListItems = document.querySelectorAll(".leftlist li");
      const rightPartBlocks = document.querySelectorAll(".rightPart");

      leftListItems[0].classList.add("itemactive");
      rightPartBlocks[0].classList.add("active");

      leftListItems.forEach(function(leftListItem, index) {
        leftListItem.addEventListener("click", function() {
   
          leftListItems.forEach(function(item) {
            item.classList.remove("itemactive");
          });
          rightPartBlocks.forEach(function(rightPartBlock) {
            rightPartBlock.classList.remove("active");
          });

          leftListItem.classList.add("itemactive");
          rightPartBlocks[index].classList.add("active");
        });
      });
    });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__homeCountdownBarInitialized) {
      return;
    }

    window.__homeCountdownBarInitialized = true;

    const padNumber = (value) => String(value).padStart(2, '0');

    const updateCountdown = (countdown) => {
      const endValue = countdown.getAttribute('data-end');
      if (!endValue) {
        return;
      }

      const endTime = new Date(endValue).getTime();
      if (Number.isNaN(endTime)) {
        return;
      }

      const remaining = Math.max(0, endTime - Date.now());
      const parts = {
        days: padNumber(Math.floor(remaining / 86400000)),
        hours: padNumber(Math.floor((remaining % 86400000) / 3600000)),
        minutes: padNumber(Math.floor((remaining % 3600000) / 60000)),
        seconds: padNumber(Math.floor((remaining % 60000) / 1000)),
      };

      Object.keys(parts).forEach((key) => {
        const field = countdown.querySelector(`[data-${key}]`);
        if (field) {
          field.textContent = parts[key];
        }
      });

      if (remaining === 0) {
        countdown.classList.add('is-ended');
      }
    };

    const syncCountdowns = () => {
      document.querySelectorAll('[data-home-countdown]').forEach(updateCountdown);
    };

    const initCountdowns = () => {
      if (!document.querySelector('[data-home-countdown]')) {
        return;
      }

      syncCountdowns();

      if (!window.__homeCountdownBarTimer) {
        window.__homeCountdownBarTimer = window.setInterval(syncCountdowns, 1000);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdowns, { once: true });
    } else {
      initCountdowns();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memorial-global-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-memorial-global-countdown]');
    if (!roots.length) {
      return;
    }

    const pad = (value) => String(value).padStart(2, '0');

    const updateRoot = (root) => {
      const endValue = root.getAttribute('data-end');
      if (!endValue) {
        return false;
      }

      const target = new Date(endValue).getTime();
      if (Number.isNaN(target)) {
        return false;
      }

      const remaining = Math.max(0, target - Date.now());
      const values = {
        days: pad(Math.floor(remaining / 86400000)),
        hours: pad(Math.floor((remaining % 86400000) / 3600000)),
        minutes: pad(Math.floor((remaining % 3600000) / 60000)),
        seconds: pad(Math.floor((remaining % 60000) / 1000)),
      };

      Object.entries(values).forEach(([key, value]) => {
        root.querySelectorAll(`[data-${key}]`).forEach((node) => {
          node.textContent = value;
        });
      });

      if (remaining === 0) {
        root.style.display = 'none';
        return false;
      }

      return true;
    };

    let hasActiveCountdown = false;

    const sync = () => {
      hasActiveCountdown = false;
      roots.forEach((root) => {
        if (updateRoot(root)) {
          hasActiveCountdown = true;
        }
      });

      if (!hasActiveCountdown && window.__memorialGlobalCountdownTimer) {
        window.clearInterval(window.__memorialGlobalCountdownTimer);
        window.__memorialGlobalCountdownTimer = null;
      }
    };

    sync();

    if (!window.__memorialGlobalCountdownTimer && hasActiveCountdown) {
      window.__memorialGlobalCountdownTimer = window.setInterval(sync, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
